import {useEffect} from 'react'
import {BookingExtraEditModalHeader} from './BookingExtraEditModalHeader'
import {BookingExtraEditModalFormWrapper} from './BookingExtraEditModalFormWrapper'

const BookingExtraEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_BookingExtra'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-350'>
        {/* begin::Modal content */}
          <div className='modal-content'>
            <BookingExtraEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-5 my-1'>
              <BookingExtraEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {BookingExtraEditModal}
